import React, { Component } from 'react'
import { Link } from "react-router-dom";
import '@progress/kendo-theme-default/dist/all.css';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import Loading from './Loading'
import styles from '../css/category.module.css';

export class CategoryList extends Component {
    state = {
        items: [],
        showLoading: false,
        selected: 0,
        childItems: [],
        parentItems:[],
        id: "",
        name:"",
        root:true
    }

    loadCategory = () => {
        this.setState({ showLoading: true });
        fetch('https://fatianshi.blob.core.chinacloudapi.cn/resource/templatecategory.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(Response => Response.json()).then(
            json => {
                //   console.log(json)
                this.setState({ items: json, showLoading: false });
            }

        )
    }

    handleSelect = (e) => {
        this.setState({ selected: e.selected, id: this.state.items.filter(item => !item.parentId && item.code !== 'K')[e.selected].id })
    }

    showRoot = () => {
        this.setState({ root: true, parentItems: [], childItems:[] });
    }

    handleClick = (id,name) => {
        this.setState({ showLoading: true });
        this.setState({ id: id,name:name, root: false }, () => {
            fetch('/api/template/FindParentTemplateCategories?id='+id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(Response => Response.json()).then(
                json => {
                    console.log(json)
                    this.setState({ parentItems: json, showLoading: false });
                }

            )

            fetch('/api/template/FindChildTemplateCategories?id=' + id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(Response => Response.json()).then(
                json => {
                    console.log(json)
                    this.setState({ childItems: json });
                }

            )
        })
    }

    componentDidMount() {
        this.loadCategory();
    }

    render() {
        return (
            <div className="classification w-100">

                {this.state.root ? (
                    <TabStrip selected={this.state.selected} onSelect={this.handleSelect}>
                        {
                            this.state.items.filter(item => !item.parentId && item.code !== 'K').map(parent =>
                                (<TabStripTab key={parent.id} title={parent.name}>
                                    <h4 className="mt-3 mb-3">下级分类</h4>
                                    <ul className="classification-children">{this.state.items.filter(child => child.parentId === parent.id).map(item => (<li key={item.id} onClick={this.handleClick.bind(this, item.id,item.name)}>{item.name}</li>))}</ul>
                                </TabStripTab>))
                        }
                    </TabStrip>
                ): (
                        <div>
                            <ul className="classification-index">
                                <li className="pr-1" onClick={this.showRoot}>所有分类</li>
                                {this.state.parentItems.map(item => (<li key={item.Id} onClick={this.handleClick.bind(this, item.Id,item.Name)}> > {item.Name}</li>))}
                            </ul>
                            <h4 className="mt-3 mb-3">下级分类</h4>
                            <ul className="classification-children">{this.state.childItems.map(item => (<li key={item.Id} onClick={this.handleClick.bind(this, item.Id,item.Name)}>{item.Name}</li>))}</ul>
                            <Link className="fts-btn fts-btn-primary to-action" to={'/Search?category=' + this.state.id + '&categoryName=' + this.state.name}>查看当前分类下的文本 →</Link>
                        </div>
                    )}

       
                <Loading isLoading={this.state.showLoading} />
            </div>

        )
    }
}

export default CategoryList